import { useNavigate } from 'react-router-dom';
import { useGetBrandKitsQuery } from '../../../features/brand-kit/brandKitApi';
import { Plus, Edit2, Palette, Type } from 'lucide-react';
import svgPaths from "../../../imports/svg-p6cob5xqk8";

const Illustration = () => (
  <div className="relative shrink-0 size-[111px]" data-name="Title=No favorites; Cololr=purple; Fill=gradient;">
    {/* Background */}
    <div className="absolute h-[92.694px] left-[6.73px] top-[15.1px] w-[89.757px]" data-name="background">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 90 93">
        <g id="background">
          <circle cx="51.5231" cy="51.0875" fill="var(--fill-0, #E4E7EC)" id="Ellipse 5" r="38.2339" />
          <circle cx="8.71428" cy="40.3032" fill="var(--fill-0, #E4E7EC)" id="Ellipse 4" r="8.71428" />
          <circle cx="25.4894" cy="5.44644" fill="var(--fill-0, #E4E7EC)" id="Ellipse 3" r="5.44643" />
          <circle cx="85.509" cy="12.5265" fill="var(--fill-0, #E4E7EC)" id="Ellipse 2" r="4.24821" />
          <circle cx="84.2016" cy="76.3589" fill="var(--fill-0, #E4E7EC)" id="Ellipse 1" r="2.06964" />
          <path d={svgPaths.p177fd200} fill="var(--fill-0, #D0D5DD)" id="Star 1" />
          <path d={svgPaths.pa607a80} fill="var(--fill-0, #D0D5DD)" id="Star 2" />
          <path d={svgPaths.pf4dfa40} fill="var(--fill-0, #D0D5DD)" id="Star 3" />
        </g>
      </svg>
    </div>

    {/* Tags Illustration */}
    <div className="absolute contents left-[11.73px] top-[25.92px]" data-name="illustration">
      {/* Tag 1 */}
      <div className="absolute contents left-[60.54px] top-[37.32px]" data-name="tag 2">
        <div className="absolute flex h-[57.42px] items-center justify-center left-[60.54px] top-[37.32px] w-[40.809px]" style={{ "--transform-inner-width": "0", "--transform-inner-height": "0" } as React.CSSProperties}>
          <div className="flex-none rotate-[10.848deg]">
            <div className="h-[52.427px] relative w-[31.505px]">
              <div className="absolute inset-[0_0_1.3%_0]">
                <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 32 52">
                  <path d={svgPaths.p2b005980} fill="var(--fill-0, #D0D5DD)" id="Vector 2" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute flex h-[15.794px] items-center justify-center left-[74.04px] top-[49.52px] w-[17.011px]" style={{ "--transform-inner-width": "0", "--transform-inner-height": "0" } as React.CSSProperties}>
          <div className="flex-none rotate-[12.059deg]">
            <div className="h-[13.029px] relative w-[14.612px]">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15 14">
                <path d={svgPaths.p2a61380} fill="var(--fill-0, white)" id="Vector 1" />
              </svg>
            </div>
          </div>
        </div>
        <div className="absolute left-[75.35px] size-[5.664px] top-[78.93px]" data-name="Ellipse">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 6 6">
            <circle cx="2.83214" cy="2.83214" fill="var(--fill-0, #E4E7EC)" id="Ellipse" r="2.83214" />
          </svg>
        </div>
      </div>

      {/* Tag 2 */}
      <div className="absolute contents left-[11.73px] top-[25.92px]" data-name="tag 1">
        <div className="absolute flex h-[80.313px] items-center justify-center left-[11.73px] top-[25.92px] w-[63.525px]" style={{ "--transform-inner-width": "0", "--transform-inner-height": "0" } as React.CSSProperties}>
          <div className="flex-none rotate-[340.089deg]">
            <div className="h-[70.15px] relative w-[42.155px]">
              <div className="absolute inset-[-1.24%_-2.07%_-0.27%_-2.07%]">
                <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 44 72">
                  <path d={svgPaths.p32f24200} fill="var(--fill-0, #F0F2F5)" id="Vector 2" stroke="var(--stroke-0, #D0D5DD)" strokeWidth="0.871428" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute flex h-[26.616px] items-center justify-center left-[25.68px] top-[41.46px] w-[27.98px]" style={{ "--transform-inner-width": "0", "--transform-inner-height": "0" } as React.CSSProperties}>
          <div className="flex-none rotate-[338.575deg]">
            <div className="h-[19.854px] relative w-[22.266px]">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 23 20">
                <path d={svgPaths.p220b2480} fill="var(--fill-0, #D0D5DD)" id="Vector 1" stroke="var(--stroke-0, #D0D5DD)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.881822" />
              </svg>
            </div>
          </div>
        </div>
        <div className="absolute left-[48.12px] size-[7.189px] top-[82.41px]" data-name="Ellipse">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 8 8">
            <circle cx="3.59464" cy="3.59464" fill="var(--fill-0, #D0D5DD)" id="Ellipse" r="3.59464" />
          </svg>
        </div>
      </div>
    </div>
  </div>
);

const EmptyState = ({ onAdd }: { onAdd: () => void }) => (
  <div className="bg-gray-50 content-stretch flex flex-col h-[231px] items-center justify-center relative shrink-0 w-full rounded-[8px] border border-dashed border-gray-200">
    <div className="content-stretch flex flex-col gap-[12px] items-center relative shrink-0">
      <div className="content-stretch flex flex-col gap-[8px] items-center relative shrink-0">
        <Illustration />
        <div className="flex flex-col font-sans font-medium justify-center leading-[0] relative shrink-0 text-[#101928] text-[14px] text-nowrap" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
          <p className="leading-[normal] whitespace-pre">Templates created based on your brand will show here</p>
        </div>
      </div>
      <button
        onClick={onAdd}
        className="bg-[#30a84b] content-stretch flex gap-[4px] h-[36px] items-center justify-center px-[16px] py-[12px] relative rounded-[6px] shrink-0 hover:bg-[#288e3e] transition-colors"
      >
        <p className="font-sans font-semibold leading-[normal] relative shrink-0 text-[14px] text-nowrap text-white" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
          Create new brand kit
        </p>
      </button>
    </div>
  </div>
);

const BrandKitCard = ({ name, category, logos, colors, onClick }: { name: string, category: string, logos: any, colors: any[], onClick: () => void }) => {
  const mainLogo = logos?.main || logos?.light || logos?.secondary;
  const primaryColors = colors?.[0]?.colors?.slice(0, 4) || [];

  return (
    <div
      className="bg-white border border-[#e4e7ec] rounded-[8px] p-4 flex flex-col gap-3 min-w-[200px] cursor-pointer hover:shadow-md transition-all group relative overflow-hidden h-[137px]"
      onClick={onClick}
    >
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-0.5 max-w-[140px]">
          <h4 className="font-bold text-[14px] text-[#1D2739] truncate">{name}</h4>
          <p className="text-[11px] text-[#667185] truncate">{category || 'General'}</p>
        </div>
        <div className="size-8 bg-gray-50 rounded flex items-center justify-center overflow-hidden border border-gray-100 shrink-0">
          {mainLogo ? (
            <img src={mainLogo} alt={name} className="size-full object-contain p-1" />
          ) : (
            <Palette size={16} className="text-gray-300" />
          )}
        </div>
      </div>

      <div className="mt-auto flex items-end justify-between">
        <div className="flex -space-x-1.5">
          {primaryColors.map((color: string, i: number) => (
            <div
              key={i}
              className="size-5 rounded-full border-2 border-white shadow-sm"
              style={{ backgroundColor: color }}
            />
          ))}
          {primaryColors.length === 0 && (
            <div className="flex gap-1 text-[#98A2B3]">
              <Palette size={12} />
              <Type size={12} />
            </div>
          )}
        </div>
        <div className="bg-[#E7F6EC] text-[#036B26] p-1 rounded group-hover:bg-[#30A84B] group-hover:text-white transition-colors">
          <Edit2 size={12} />
        </div>
      </div>
    </div>
  );
};

export const BrandKit = () => {
  const navigate = useNavigate();
  const { data: brandKitsData, isLoading } = useGetBrandKitsQuery({ limit: 5 });
  const brandKits = brandKitsData?.data || [];

  if (isLoading) {
    return (
      <div className="content-stretch flex flex-col gap-[14px] items-start relative shrink-0 w-full animate-pulse">
        <div className="h-6 w-32 bg-gray-200 rounded mb-2" />
        <div className="flex gap-4 w-full overflow-x-auto pb-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-[137px] w-[200px] bg-gray-100 rounded-[8px] shrink-0" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="content-stretch flex flex-col gap-[14px] items-start relative shrink-0 w-full">
      <div className="flex items-center justify-between w-full">
        <div className="flex flex-col font-sans font-bold justify-center leading-[0] relative shrink-0 text-[#1d2739] text-[18px] text-nowrap" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
          <p className="leading-[normal] whitespace-pre">Your Brand Kit</p>
        </div>
        {brandKits.length > 0 && (
          <button
            onClick={() => navigate('/brand-kit')}
            className="text-[13px] font-medium text-[#227735] hover:underline"
          >
            View All
          </button>
        )}
      </div>

      {brandKits.length === 0 ? (
        <EmptyState onAdd={() => navigate('/brand-kit')} />
      ) : (
        <div className="flex gap-[16px] items-center relative shrink-0 w-full overflow-x-auto pb-2 scrollbar-hide">
          <div
            className="bg-gray-50 border border-[#e4e7ec] border-dashed rounded-[8px] h-[137px] w-[60px] flex flex-col items-center justify-center cursor-pointer hover:bg-gray-100 transition-colors shrink-0"
            onClick={() => navigate('/brand-kit')}
          >
            <Plus size={20} className="text-[#667185]" />
          </div>
          {brandKits.map((kit: any) => (
            <BrandKitCard
              key={kit.id || (kit as any)._id}
              name={kit.name}
              category={kit.category}
              logos={kit.logos}
              colors={kit.colors}
              onClick={() => navigate(`/brand-kit/edit/${kit.id || (kit as any)._id}`)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

